export default [
  [`Рост`, `104`, `110`, `116`, `122`, `128`, `134`, `140`, `146`, `152`],
  [`Размер`, `26`, `28`, `30`, `32`, `34`, `36`, `38`, `40`, `42`],
  [
    `Обхват груди`,
    `55-57`,
    `56-58`,
    `57-59`,
    `58-62`,
    `61-65`,
    `64-68`,
    `67-71`,
    `70-74`,
    `73-77`
  ],
  [
    `Обхват талии, см`,
    `52-54`,
    `53-55`,
    `54-56`,
    `55-58`,
    `57-59`,
    `58-61`,
    `60-62`,
    `61-64`,
    `63-65`
  ],
  [
    `Обхват бёдер, см`,
    `57-60`,
    `59-62`,
    `61-64`,
    `63-67`,
    `66-70`,
    `69-73`,
    `72-76`,
    `75-79`,
    `79-83`
  ]
];
